import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ModelVolumeComponentSearch} from "./ModelVolumeComponentSearch";

const vUI_Published_Model_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_PUBLISHED_MODEL_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB Published Model Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    PUBLISHED_MODEL_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Published Model Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    PUBLISHED_MODEL_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Published Model Id', columnResourceName: 'colPId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    PUBLISHED_MODEL_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Published Model Type', columnResourceName: 'colType', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    EFFECTIVE_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {columnName: 'Validity Start Date', columnResourceName: 'colStartDt', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    EFFECTIVE_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {columnName: 'Validity End Date', columnResourceName: 'colEndDt', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }


};

const PublishedModelSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_PUBLISHED_MODEL_ID',
        id_ui: 'PUBLISHED_MODEL_ID',
        name: 'PUBLISHED_MODEL_NAME'

    },

    searchProviderFields: vUI_Published_Model_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Published_Model_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const PublishedModelSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "PublishedModelSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'PUBLISHED_MODEL_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PUBLISHED_MODEL_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'PUBLISHED_MODEL_NAME', 'PUBLISHED_MODEL_TYPE', 'EFFECTIVE_START_DT',
        'EFFECTIVE_END_DT',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PublishedModelSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const PublishedModelSearch: ISearch = {
    searchName: "Find Published Model",
    renderOptions: {ui5ResourceId: "PublishedModelSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PublishedModelSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("PublishedModelBO", "PublishedModel", PublishedModelSearch, "Published Model Search")


export {PublishedModelSearch}